/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon20Regular = forwardRef('UiCursorAIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.001 4.093c.002-1.648 1.885-2.587 3.202-1.597l9.852 7.406c1.536 1.155.717 3.601-1.205 3.599l-4.912-.006a.5.5 0 0 0-.4.2l-2.952 3.927c-1.155 1.536-3.6.717-3.599-1.205l.014-12.324Zm2.3-.398a.5.5 0 0 0-.8.4l-.014 12.324a.5.5 0 0 0 .9.301l2.952-3.926a2 2 0 0 1 1.6-.799l4.913.006a.5.5 0 0 0 .301-.9L6.302 3.695Z" })));
});
